import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getExcessStockBundlesSummary = (page, pagesize, search, ordering) => {
  return axios.get(
    API_URL +
    '/api/' +
    API_VERSION +
    '/excess-stock/get-excess-stock-bundles-summary/',
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};

const getExcessStockPrintById = id => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/excess-stock/excess-party-print/?excess_stock_id=${id}`,
    {
      headers: authHeader(),
    },
  );
};


const getExcessBundlesSummary = (page, pagesize, search, ordering) => {
  return axios.get(
    API_URL + '/api/' + API_VERSION + '/excess-stock/excess-stock-bundles/',
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};

const getExcessStockBundles = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/excess-stock/', {
    headers: authHeader(),
    params: {
      fields: 'id,bundle_inward__id,bundle_inward__bundle_no,die_profile__die_number,length,pieces,weight,alloy__name,alloy__color_code,temper__name,temper__code,status,die_profile__die_diagram,avg_weight,bundle_inward__packing_date,die_profile__dimension1,die_profile__dimension2,die_profile__dimension3,die_profile__dimension4,bundle_inward__status,deleted',
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const getExcessStockById = id => {
  return axios.get(`${API_URL}/api/${API_VERSION}/excess-stock/${id}`, {
    headers: authHeader(),
  });
};
const getArchiveExcessStockBundlesSummary = (
  page,
  pagesize,
  search,
  ordering,
) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/alloy/?deleted=1', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const getArchiveExcessStockBundles = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/alloy/?deleted=1', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const addExcessStock = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/excess-stock/`,
    formData, // Payload for the request body
    { headers: authHeader() },
  );
};

const ShiftBundleToExcessStock = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/excess-stock/shift-bundles-to-workorder/`,
    formData, // Payload for the request body
    { headers: authHeader() },
  );
};

const updateExcessStock = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/conversion-rate/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() },
  );
};

const deleteExcessStock = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/excess-stock/${id}/`, // Include `id` in the URL
    {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data', // Ensure proper header for FormData
      },
    },
  );
};

const unArchiveExcessStock = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/conversion-rate/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() }, // Authentication header
  );
};

const ExcessStockService = {
  getExcessStockBundlesSummary,
  getExcessStockBundles,
  getArchiveExcessStockBundlesSummary,
  getArchiveExcessStockBundles,
  addExcessStock,
  updateExcessStock,
  unArchiveExcessStock,
  deleteExcessStock,
  getExcessStockById,
  getExcessStockPrintById,
  getExcessBundlesSummary,
  ShiftBundleToExcessStock,

};

export default ExcessStockService;
